module.exports = __webpack_public_path__ + "static/img/kanfa.c2f9c690.png";